<div class="kavalli-card-dep" (click)="selected.emit(departaments)">
   <div class="kavalli-card-dep__container">
      <h3>{{ departaments?.displayName }}</h3>
      <img src="{{ departaments?.icon }}" alt="" />
   </div>
</div>
